import axios from 'axios';
import config from '@assets/config.json'; // api 请求json
import qs from "qs";

const state = {
    activityList: [], // 活动信息,
}
const mutations = {
    setActivity(state, data) {
        state.activityList = data;
    },
}
const getters = {
    getActivity: state => {
        return state.activityList;
    },
}
const actions = {
    getActivity({ rootState, commit }, opt) { // 获取活动信息
        return new Promise((resolve, reject) => {
            axios.post(`${config.api.reqApi}/api/activity/GetByCompId`, opt, rootState.header).then(data => {
                if (data.data) {
                    commit('setActivity', data.data );
                    resolve(data.data);
                };
            }).catch((err) => {
                console.log(err.response.data);
            });
        });
    },
    addActivity({ rootState }, opt) { // 添加活动信息
        return new Promise((resolve, reject) => {
          axios.post(`${config.api.reqApi}/api/activity`, opt, rootState.header).then(data => {
            if (data.data) {
                resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
    },
    delActivity({ rootState }, id) { // 删除活动信息
        return new Promise((resolve, reject) => {
          axios.delete(`${config.api.reqApi}/api/activity?id=${id}`, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
    },
    editActivity({ rootState }, opt) { // 修改活动信息
        return new Promise((resolve, reject) => {
          axios.put(`${config.api.reqApi}/api/activity`, opt, rootState.header).then(data => {
            if (data.data) {
              resolve(data.data);
            }
          }).catch((err) => {
            console.log(err.response.data);
          });
        });
    },

    
    getActivityRes({ rootState }, opt) { // 获取用户报名记录
      return new Promise((resolve, reject) => {
        axios.post(`${config.api.reqApi}/api/ActivityApply/GetByActId`, opt, rootState.header).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
    getActivityMes({ rootState }, opt) { // 获取活动留言
      return new Promise((resolve, reject) => {
        axios.post(`${config.api.reqApi}/api/ActivityComment/GetByActId`, opt, rootState.header).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
    sendActivityMes({ rootState }, opt) { // 回复活动留言
      return new Promise((resolve, reject) => {
        axios.post(`${config.api.reqApi}/api/ActivityComment`, opt, rootState.header).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
    delActivityMes({ rootState }, id) { // 删除活动留言
      return new Promise((resolve, reject) => {
        axios.delete(`${config.api.reqApi}/api/ActivityComment?id=${id}`, rootState.header).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
  }
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
} 